import EnrolmentsAdapter from './base';

export default class Unenrolment extends EnrolmentsAdapter {
  modelNamePlural = 'unenrolments';
}
